import { BaseModalProps, CheckboxField, Modal, OperationButton } from 'components/core-v2'
import { required } from 'components/core-v2/molecules/fields/validators'
import { useParams } from 'react-router-dom'

import classes from './confirmation-modal.module.scss'

const nameMap = {
  approve: 'approval',
  commitment: 'commitment',
  settlement: 'settlement',
  activate: 'activation'
}

interface Props extends BaseModalProps {
  isLoading: boolean
  onSubmit: (e: any) => any
}
export const ConfirmationModal = ({ isLoading, isOpen, onClose, onSubmit }: Props) => {
  const { tab } = useParams()
  return (
    <Modal.Wrapper aria-labelledby="confirm" isOpen={isOpen}>
      <Modal.Header id="confirm" onClose={onClose}>
        Confirm trade {nameMap[tab]}
      </Modal.Header>
      <Modal.Body className={classes.root}>
        <p>
          By ticking this box and committing to this trade, you confirm that you have the necessary
          mandate and authorisation to enter into this transaction.
        </p>
        <CheckboxField
          className={classes.checkbox}
          id="confirm-checkbox"
          label="Confirm authorisations"
          validators={required}
        />
        <div className="d-flex align-center">
          <OperationButton
            className="mr-4"
            isLoading={isLoading}
            operationType="progress"
            type="submit"
            onClick={onSubmit}
          >
            Submit
          </OperationButton>
          <OperationButton operationType="neutral" type="button" onClick={onClose}>
            Cancel
          </OperationButton>
        </div>
      </Modal.Body>
    </Modal.Wrapper>
  )
}
